import { UMAMI_WEBSITE_ID } from "./config/flags";

// Loads the Umami tracker from our own origin (/stats/ is proxied to the Umami
// container by nginx), so no request goes to a third party and nothing is
// stored in the browser. See docs/analytics.md and docs/privacy-and-consent.md.
//
// Injected from JS rather than written into public/index.html because the
// prerender step snapshots the DOM: a static tag would end up in every
// prerendered page AND be added again by this code. The hostname check keeps
// the dev server, the prerender run (localhost) and preview builds out of the
// numbers.
const PRODUCTION_HOSTS = ["malilabs.com", "www.malilabs.com"];

export const loadAnalytics = () => {
  if (!UMAMI_WEBSITE_ID || !PRODUCTION_HOSTS.includes(window.location.hostname)) return;
  const s = document.createElement("script");
  s.defer = true;
  s.src = "/stats/script.js";
  s.dataset.websiteId = UMAMI_WEBSITE_ID;
  // events go to /stats/api/send, not /api/ (that path is the blog JSON)
  s.dataset.hostUrl = `${window.location.origin}/stats`;
  s.dataset.domains = PRODUCTION_HOSTS.join(",");
  s.dataset.doNotTrack = "true";
  document.head.appendChild(s);
};
